module.exports = __webpack_public_path__ + "static/media/fish-tank-clean.12b53987.png";